import {
  OfficeWithdrawalQuestion,
  OfficeWithdrawalRequestWithdrawalForm,
} from '@/context/services/office_withdrawal/type';
import { useTranslation } from '@/i18n';
import {
  FormCheckbox,
  FormTextArea,
} from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { memo, useCallback, useMemo } from 'react';
import { Control, UseFormResetField, useWatch } from 'react-hook-form';
import styles from '../../index.module.scss';

const cx = classnames.bind(styles);

type Props = {
  question: OfficeWithdrawalQuestion;
  control: Control<OfficeWithdrawalRequestWithdrawalForm>;
  resetField: UseFormResetField<OfficeWithdrawalRequestWithdrawalForm>;
  checkboxName: keyof OfficeWithdrawalRequestWithdrawalForm;
  textName?: keyof OfficeWithdrawalRequestWithdrawalForm;
};

export const QuestionItem = memo(
  ({ question, control, resetField, checkboxName, textName }: Props) => {
    const { t } = useTranslation();
    const isChecked = useWatch({ control, name: checkboxName });

    const textAreaProps = useMemo(() => {
      return {
        disabled: !isChecked,
        placeholder: t('office_withdrawal.tell_reason'),
      };
    }, [isChecked, t]);

    const onResetTextArea = useCallback(() => {
      if (textName) {
        resetField(textName, { defaultValue: '' });
      }
    }, [resetField, textName]);

    return (
      <div className={cx(styles['withdrawal-input'])}>
        <FormCheckbox<OfficeWithdrawalRequestWithdrawalForm>
          control={control}
          name={checkboxName}
          inputId={checkboxName}
          label={question.question}
          onChangeAfter={onResetTextArea}
        />
        {question.with_text_field && textName && (
          <div className={cx(styles['withdrawal-input-text'])}>
            <FormTextArea<OfficeWithdrawalRequestWithdrawalForm>
              control={control}
              name={textName}
              inputId={textName}
              textAreaProps={textAreaProps}
            />
          </div>
        )}
      </div>
    );
  }
);

QuestionItem.displayName = 'QuestionItem';
